import React, { Component } from "react";
import { Modal } from "react-bootstrap";

export default class HyperLinkingPolicy extends Component {
  render() {
    const { show, closeModal } = this.props;
    return (
      <React.Fragment>
        <Modal show={show} dialogClassName="banner-modal" onHide={closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Hyperlinking Policy</Modal.Title>
          </Modal.Header>
          <Modal.Body className="hyperlink-policy">
            <div>Links to external websites/portals</div>
            <div>
              At many places in the portal, you shall find links to other
              websites/portals. The links have been placed for your convenience.
              PMG is not responsible for the contents and reliability of the
              linked websites and does not necessarily endorse the views
              expressed in them. Mere presence of the link or its listing on
              this portal should not be assumed as endorsement of any kind. We
              cannot guarantee that these links will work all the time and we
              have no control over availability of linked pages.
            </div>
            <div>Links to PMG website by other websites</div>
            <div>
              We do not object to you linking directly to the information that
              is hosted on this site and no prior permission is required for the
              same. However, we would like you to inform us about any links
              provided to this portal so that you can be informed of any changes
              or modifications therein. Also, we do not permit our pages to be
              loaded into frames on your site. The pages belonging to this site
              must load into a newly opened browser window of the User.
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}
